<div class="filter-sort">
    <las-assignments-filter
        [assignments]="_flatAssignments"
        (onAssignmentsChanged)="onAssignmentsChanged($event)"
        (onFilterReset)="onCollectionReset()"
    >
    </las-assignments-filter>
</div>
<div *ngIf="displayedAssignments">
    <div *ngIf="displayedAssignments.length; else empty">
        <div class="table-wrapper">
            <table class="table">
            <thead class="thead-inverse">
                <tr>
                    <th
                        class="narrow-col sortable"
                        tabindex="0"
                        [attr.aria-sort]="ariaSort(Column.Bill)"
                        (click)="doSort(Column.Bill)"
                        (keydown.enter)="doSort(Column.Bill)"
                        (keydown.space)="$event.preventDefault(); doSort(Column.Bill)"
                    >
                        <strong>Bill</strong>
                        <mat-icon *ngIf="sortColumn === Column.Bill">{{
                            ascending
                                ? ArrowIcon.Ascending
                                : ArrowIcon.Descending
                        }}</mat-icon>
                    </th>
                    <th
                        class="wide-col sortable"
                        tabindex="0"
                        [attr.aria-sort]="ariaSort(Column.BillTitle)"
                        (click)="doSort(Column.BillTitle)"
                        (keydown.enter)="doSort(Column.BillTitle)"
                        (keydown.space)="$event.preventDefault(); doSort(Column.BillTitle)"
                    >
                        <strong>Bill Title</strong>
                        <mat-icon *ngIf="sortColumn === Column.BillTitle">{{
                            ascending
                                ? ArrowIcon.Ascending
                                : ArrowIcon.Descending
                        }}</mat-icon>
                    </th>
                    <th
                        class="normal-col sortable"
                        tabindex="0"
                        [attr.aria-sort]="ariaSort(Column.RequestType)"
                        (click)="doSort(Column.RequestType)"
                        (keydown.enter)="doSort(Column.RequestType)"
                        (keydown.space)="$event.preventDefault(); doSort(Column.RequestType)"
                    >
                        <strong>Request Type</strong>
                        <mat-icon *ngIf="sortColumn === Column.RequestType">{{
                            ascending
                                ? ArrowIcon.Ascending
                                : ArrowIcon.Descending
                        }}</mat-icon>
                    </th>
                    <th
                        class="normal-col sortable"
                        tabindex="0"
                        [attr.aria-sort]="ariaSort(Column.RequestStatus)"
                        (click)="doSort(Column.RequestStatus)"
                        (keydown.enter)="doSort(Column.RequestStatus)"
                        (keydown.space)="$event.preventDefault(); doSort(Column.RequestStatus)"
                    >
                        <strong>Request Status</strong>
                        <mat-icon *ngIf="sortColumn === Column.RequestStatus">{{
                            ascending
                                ? ArrowIcon.Ascending
                                : ArrowIcon.Descending
                        }}</mat-icon>
                    </th>
                    <th
                        class="normal-col sortable"
                        tabindex="0"
                        [attr.aria-sort]="ariaSort(Column.Priority)"
                        (click)="doSort(Column.Priority)"
                        (keydown.enter)="doSort(Column.Priority)"
                        (keydown.space)="$event.preventDefault(); doSort(Column.Priority)"
                    >
                        <strong>Priority</strong>
                        <mat-icon *ngIf="sortColumn === Column.Priority">{{
                            ascending
                                ? ArrowIcon.Ascending
                                : ArrowIcon.Descending
                        }}</mat-icon>
                    </th>
                    <th
                        class="normal-col sortable"
                        tabindex="0"
                        [attr.aria-sort]="ariaSort(Column.Task)"
                        (click)="doSort(Column.Task)"
                        (keydown.enter)="doSort(Column.Task)"
                        (keydown.space)="$event.preventDefault(); doSort(Column.Task)"
                    >
                        <strong>Task</strong>
                        <mat-icon *ngIf="sortColumn === Column.Task">{{
                            ascending
                                ? ArrowIcon.Ascending
                                : ArrowIcon.Descending
                        }}</mat-icon>
                    </th>
                    <th
                        class="normal-col sortable"
                        tabindex="0"
                        [attr.aria-sort]="ariaSort(Column.TaskDue)"
                        (click)="doSort(Column.TaskDue)"
                        (keydown.enter)="doSort(Column.TaskDue)"
                        (keydown.space)="$event.preventDefault(); doSort(Column.TaskDue)"
                    >
                        <strong>Task Due</strong>
                        <mat-icon *ngIf="sortColumn === Column.TaskDue">{{
                            ascending
                                ? ArrowIcon.Ascending
                                : ArrowIcon.Descending
                        }}</mat-icon>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    *ngFor="
                        let assignment of displayedAssignments
                            | billSort: sortColumn : ascending
                            | assignmentSort: sortColumn : ascending
                    "
                >
                    <td>
                        <a
                            [routerLink]="['/bills', assignment.billID]"
                            [attr.aria-label]="
                                'View bill ' +
                                assignment.measure +
                                ': ' +
                                assignment.subject
                            "
                        >
                            <strong>{{ assignment.measure }}</strong>
                        </a>
                    </td>
                    <td>{{ assignment.subject }}</td>
                    <td>
                        <a
                            [routerLink]="['/requests', assignment.id]"
                            [attr.aria-label]="
                                assignment.requestType +
                                ' request for ' +
                                assignment.measure +
                                ', task: ' +
                                assignment.assignmentTask +
                                '. assignment id: ' +
                                assignment.id
                            "
                        >
                            {{ assignment.requestType }}
                        </a>
                    </td>
                    <td>{{ assignment.requestStatus }}</td>
                    <td>{{ assignment.requestPriority }}</td>
                    <td>{{ assignment.assignmentTask }}</td>
                    <td>
                        {{
                            assignment.assignmentDue
                                | date: "mediumDate" : "PST"
                        }}
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
    </div>
</div>

<ng-template #empty>
    <h3>No assignments.</h3>
</ng-template>
